<template>
  <div class="px-2">
    <div class="mb-1">
      <v-btn class="mr-2" v-if="report && !capturing" @click="printData" x-small width="30" height="30"
             color="primary">
        <v-icon x-small>fas fa-print</v-icon>
      </v-btn>

      <v-btn v-if="report && !capturing" @click="saveDocument" x-small
             width="30" height="30"
             color="primary">
        <v-icon x-small>fas fa-save</v-icon>
      </v-btn>
    </div>
    <div v-if="report" v-html="report">
    </div>
    <div class="d-flex justify-center align-center" style="height: 90vh" v-if="errorMessage">
      <h1 class="error--text">{{ errorMessage }}</h1>
    </div>
  </div>
</template>

<script>
import {downloadTextFile, parseTextToHtml, wrapItem} from "@/utils/pureFunctions";

export default {
  name: "salary-info",
  props: ['creditId'],
  data() {
    return {
      report: null,
      errorMessage: null,
      capturing: false
    }
  },
  methods: {
    saveDocument() {
      this.capturing = true
      this.$nextTick(() => {
        downloadTextFile('user-info.html', document.querySelector("html").innerHTML)
        this.capturing = false
      })
    },
    setError(e) {
      if (e.response && e.response.data && e.response.data.message) {
        this.errorMessage = e.response.data.message
      }
    },
    printData() {
      this.isShowPrintBtn = false
      this.$nextTick(() => {
        window.print()
        this.isShowPrintBtn = true
      })
    },

    async getReportByCreditId() {
      try {
        this.errorMessage = null
        const {data: {data}} = await this.$http.get(`/admin/credit/katm/salary-info/${this.creditId}`)
        this.report = parseTextToHtml(data)
      } catch (e) {
        this.$setResponseError({error: e})
        this.setError(e)
      }
    },
    async getReportByUser({
                            pnfl,
                            passport_series,
                            passport_number,
                            region_katm_code,
                            district_katm_code,
                            user_phone,
                            credit_id
                          }) {
      try {
        let formData = {
          pnfl,
          passport_series,
          passport_number,
          user_phone,
          district_katm_code,
          region_katm_code,
        }
        if (credit_id) {
          formData.credit_id = credit_id
        }
        const {data: {data}} = await this.$http.post('admin/calculate/katm-salary', formData)
        this.report = parseTextToHtml(data)
      } catch (e) {
        this.$setResponseError({error: e})
        this.setError(e)
      }

    }
  },
  computed: {
    isReportByCreditId() {
      return !!this.creditId
    }

  },
  async mounted() {
    const {
      pnfl,
      passport_series,
      passport_number,
      region_katm_code,
      district_katm_code,
      user_phone,
      credit_id
    } = this.$route.query
    this.$showLoading()
    if (this.isReportByCreditId) {
      await this.getReportByCreditId()
    } else if (pnfl && passport_number && passport_series && region_katm_code && district_katm_code && user_phone) {
      await this.getReportByUser({
        pnfl,
        passport_series,
        passport_number,
        region_katm_code,
        district_katm_code,
        user_phone,
        credit_id
      })
    }
    Array.prototype.forEach.call(document.querySelectorAll('table'), item => {
      const wrapper = document.createElement('div')
      wrapper.className = 'table-wrapper'
      wrapItem(item, wrapper)
    })
    this.$clearLoading()
  }
}
</script>


<style lang="scss">
.print-btn {
  left: 70px;
  top: 100px;
  position: absolute;
}

.template {
  display: block;
  min-height: 29cm;
  margin: auto;
  padding: 1.5cm;
}

.temp-h {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}

.temp-h img {
  width: 25%;
  flex-grow: 0;
  flex-shrink: 0;
  object-fit: contain;
}

.temp-h h3 {
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  flex-grow: 1;
  line-height: 1.5;
  color: #004982;
  margin: 0;
  padding: 0;
  width: 1%;
}

.temp-h-sub {
  display: block;
  border: 2px solid #004982;
  border-width: 2px 0;
  padding: 5px 0;
}

.temp-h-sub ul {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding: 0;
  margin: 0;
}

h1.temp-title {
  display: block;
  text-align: center;
  font-size: 12px;
  color: #959595;
  margin: 10px 0px;
}

.temp-table {
  margin-bottom: 20px;
  font-size: 12px;
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 10px;

}

.temp-table tr + tr {
  border-top: 1px solid #E5E5E5;
}

.temp-table tr:first-child {

  td {
    padding: 10px 0;
  }

}

.temp-table tr:last-child {

  td {
    padding-bottom: 15px;
  }

}


.temp-table td, .temp-table th {
  padding: 4px 5px;
  color: #000;
  line-height: 1;
  vertical-align: middle;
  text-align: center;
  height: 30px;
}


td.temp-table-h {
  color: #000;
  text-align: center;
  font-weight: 500;
  border: none;
}

.temp-table th {
  text-align: center;
  color: #777;
  text-transform: uppercase;
}

.temp-f p {
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: #777;
  line-height: 1.5;
}

.temp-table td:first-child {
  text-align: center;
  width: 30px;
}

.temp-table td:last-child {
  text-align: center;
}

.temp-table-footer {
  margin-bottom: 20px;
  border-bottom: 1px;
  font-size: 12px;
  width: 100%;
}

.temp-table-footer, .temp-table-footer td, .temp-table-footer th {
  border-top: 0;
  border-collapse: collapse;
}

.temp-table-footer td, .temp-table-footer th {
  padding: 4px 5px;
  color: #000;
  line-height: 1;
  vertical-align: middle;
  text-align: center;
}

#table_incoms {
  margin-top: 10px;
  margin-bottom: 0;
  white-space: nowrap;
}

.table-wrapper {
  overflow: auto;
}

@media screen and (max-width: 599px) {
  .temp-h {
    flex-direction: column;
    justify-content: center;

    &-sub ul {
      flex-direction: column;
    }

    h3 {
      width: 100%;
    }
  }
  .template {
    padding: 0;
  }
}


</style>